import React, { useState } from 'react';


function ReadMoreParagraph({ text, maxLength }) {
    const [showFullText, setShowFullText] = useState(false);

    const toggleShowFullText = () => {
        setShowFullText(!showFullText);
    };


    const displayText = showFullText ? text : text.slice(0, maxLength) + '...';

    return (
        <div>
            <span className={`intro ${showFullText ? 'full-text' : 'truncated-text'}`} dangerouslySetInnerHTML={{ __html: showFullText ? displayText : displayText}} />
            {/* <span  className={`intro ${showFullText ? 'full-text' : 'truncated-text'}`}>{displayText} </p> */}


            <span className='btn_readMore' onClick={toggleShowFullText}>
                {showFullText ? <>Read Less<i className="bi bi-chevron-double-up"></i></> : <>Read More<i className="bi bi-chevron-double-down"></i></>}
            </span>
        </div>
    );
}

export default ReadMoreParagraph;
